import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NotificationService } from '@services/notification.service';

@Component({
	selector: 'app-notificationcenter',
	templateUrl: './notificationcenter.component.html',
	styleUrls: ['./notificationcenter.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class NotificationcenterComponent implements OnInit {
	@Input()
	public visible: boolean = false;

	constructor(public notificationService: NotificationService) {}

	ngOnInit(): void {}
}
